
import DefaultController from '../controller';
import SimpleEvent from './../event';

class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.type = 'link';

        this.isHover = false;

    }

    reset(renderer){
        this.isHover = false;
        super.reset(renderer);
    }

    setEvents(renderer){
        
        super.setEvents(renderer);

        let node = renderer.getEventBindingElement(this);
        if(! node){
            return;
        }

        this.addEvent(new SimpleEvent(node, 'click', [this, this.linkClick]));
        this.addEvent(new SimpleEvent(node, 'mouseover', [this, this.setHover, true]));
        this.addEvent(new SimpleEvent(node, 'mouseout', [this, this.setHover, false]));

    }

    linkClick(event){
        if(this.renderOutput.result){
            let href = this.renderOutput.result.getAttribute('href');
            if(! href || href == '' || href == '#' ){
                event.preventDefault();
            }
        }
    }

    setHover(event, isHover=true){
        this.isHover = isHover;
        this.update();
    }
    
    
}

// you can extend a blue print for a parent component by importing it
// and using let Blueprint = Object.assign(parentBlueprint, {my: 'settings'});

let Blueprint = {
    type: Controller,
    properties: { 
        style: {
            textDecoration: 'none',
            color: 'black'
        },
        attributes: { 'href': '' }
      },
    events: {  
    },
    children: []
}

export default Blueprint;
export {Controller};
